// PROMPT 146 - Plantillas de WhatsApp: los mismos limites y reglas que el servidor
// (backend/agente_wa/plantillas.py). Sirve para avisar mientras se escribe; el servidor vuelve a validar todo.

export const LIMITES = {
  nombre: 512,
  encabezado: 60,
  cuerpo: 1024,
  pie: 60,
  boton: 25,
  botones: 10,
  rapidas: 10,
  urls: 2,
  telefonos: 1,
  url: 2000,
  telefono: 20,
};

export const IDIOMAS = [
  { codigo: "es", nombre: "Español" },
  { codigo: "en", nombre: "Inglés" },
  { codigo: "es_MX", nombre: "Español (México)" },
  { codigo: "es_AR", nombre: "Español (Argentina)" },
  { codigo: "es_ES", nombre: "Español (España)" },
  { codigo: "en_US", nombre: "Inglés (EE. UU.)" },
  { codigo: "en_GB", nombre: "Inglés (Reino Unido)" },
  { codigo: "pt_BR", nombre: "Portugués (Brasil)" },
];

export const CATEGORIAS = [
  { valor: "UTILITY", nombre: "Utilidad" },
  { valor: "MARKETING", nombre: "Marketing" },
  { valor: "AUTHENTICATION", nombre: "Autenticación" },
];

export const AYUDA_CATEGORIA =
  "Utilidad: avisos sobre una reserva o una consulta del cliente. Marketing: promociones; Meta hoy no las entrega a números de EE. UU. Meta puede cambiar la categoría al revisarla.";
export const NOTA_COSTO = "Cada plantilla entregada la cobra Meta, según la categoría y el país del cliente.";

export const AUTOCOMPLETAR = [
  { valor: "nombre", nombre: "Nombre del cliente", ejemplo: "Ana" },
  { valor: "marca", nombre: "Marca", ejemplo: "Interviajes NY" },
  { valor: "reserva", nombre: "Código de la reserva", ejemplo: "TV26-0001" },
  { valor: "tour", nombre: "Tour", ejemplo: "Boston" },
  { valor: "fecha", nombre: "Fecha", ejemplo: "15/12/2026" },
  { valor: "hora", nombre: "Hora", ejemplo: "05:50" },
  { valor: "adultos", nombre: "Cantidad de adultos", ejemplo: "2" },
  { valor: "saldo", nombre: "Saldo pendiente", ejemplo: "USD 120" },
  { valor: "punto_encuentro", nombre: "Punto de encuentro", ejemplo: "Port Authority" },
];

const TONO_GRIS = "bg-slate-100 text-slate-700 border-slate-200";
const TONO_VERDE = "bg-emerald-100 text-emerald-800 border-emerald-200";
const TONO_ROJO = "bg-red-100 text-red-800 border-red-200";
const TONO_AMBAR = "bg-amber-100 text-amber-900 border-amber-200";

export const ESTADOS = {
  APPROVED: { texto: "Aprobada", clase: TONO_VERDE },
  PENDING: { texto: "En revisión", clase: TONO_GRIS },
  IN_APPEAL: { texto: "En apelación", clase: TONO_GRIS },
  REJECTED: { texto: "Rechazada", clase: TONO_ROJO },
  PAUSED: { texto: "Pausada", clase: TONO_AMBAR },
  DISABLED: { texto: "Deshabilitada", clase: TONO_ROJO },
  PENDING_DELETION: { texto: "Borrándose", clase: TONO_GRIS },
  DELETED: { texto: "Borrada", clase: TONO_GRIS },
  ARCHIVED: { texto: "Archivada", clase: TONO_GRIS },
  LIMIT_EXCEEDED: { texto: "Límite excedido", clase: TONO_AMBAR },
};

export const FILTROS_ESTADO = [
  { valor: "TODAS", texto: "Todas" },
  { valor: "APPROVED", texto: "Aprobadas" },
  { valor: "PENDING", texto: "En revisión" },
  { valor: "REJECTED", texto: "Rechazadas" },
  { valor: "PAUSED", texto: "Pausadas" },
  { valor: "DELETED", texto: "Borradas" },
];

const CALIDADES = {
  GREEN: { texto: "Calidad alta", clase: TONO_VERDE },
  YELLOW: { texto: "Calidad media", clase: TONO_AMBAR },
  RED: { texto: "Calidad baja", clase: TONO_ROJO },
};

const MOTIVOS = {
  ABUSIVE_CONTENT: "contenido abusivo",
  INVALID_FORMAT: "formato inválido",
  PROMOTIONAL: "contenido promocional en una plantilla de utilidad",
  TAG_CONTENT_MISMATCH: "la categoría no coincide con el contenido",
  SCAM: "posible estafa",
  INCORRECT_CATEGORY: "categoría incorrecta",
};

export function estadoInfo(estado) {
  const e = String(estado || "").toUpperCase();
  return ESTADOS[e] || { texto: e ? e.replace(/_/g, " ").toLowerCase() : "Sin estado", clase: TONO_GRIS };
}

export function calidadInfo(calidad) {
  return CALIDADES[String(calidad || "").toUpperCase()] || null;
}

export function categoriaNombre(valor) {
  const c = CATEGORIAS.find((x) => x.valor === String(valor || "").toUpperCase());
  return c ? c.nombre : valor || "";
}

export function idiomaNombre(codigo) {
  const i = IDIOMAS.find((x) => x.codigo === codigo);
  return i ? i.nombre : codigo || "";
}

export function motivoTexto(codigo) {
  const m = String(codigo || "").trim().toUpperCase();
  if (!m || m === "NONE") return "";
  return MOTIVOS[m] || m.replace(/_/g, " ").toLowerCase();
}

// --------------------------------------------------------------------------------------------
// Variables {{1}}, {{2}}...
// --------------------------------------------------------------------------------------------
export function variablesDe(texto) {
  const salida = [];
  const re = /\{\{(\d+)\}\}/g;
  let m = re.exec(texto || "");
  while (m) {
    salida.push(Number(m[1]));
    m = re.exec(texto || "");
  }
  return salida;
}

const unicas = (texto) => Array.from(new Set(variablesDe(texto))).sort((a, b) => a - b);

export function proximaVariable(texto) {
  const usadas = variablesDe(texto);
  return usadas.length ? Math.max(...usadas) + 1 : 1;
}

// Nombre que acepta Meta: minusculas, numeros y guion bajo (se arregla mientras se escribe).
export function normalizarNombre(texto) {
  return String(texto || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[^a-z0-9_]+/g, "_");
}

export function variablesUsadas(d) {
  const usadas = [];
  if (d.encabezado && d.encabezado.tipo === "TEXT") {
    unicas(d.encabezado.texto).forEach((n) => usadas.push({ componente: "encabezado", n }));
  }
  unicas(d.cuerpo && d.cuerpo.texto).forEach((n) => usadas.push({ componente: "cuerpo", n }));
  (d.botones || []).forEach((b, i) => {
    if (b.tipo === "URL" && variablesDe(b.url).length) usadas.push({ componente: "boton:" + i, n: 1 });
  });
  return usadas;
}

// Deja una fila de variable (etiqueta, ejemplo, autocompletar) por cada {{n}} que de verdad se usa.
export function sincronizarVariables(d) {
  const previas = new Map((d.variables || []).map((v) => [v.componente + "#" + v.n, v]));
  const variables = variablesUsadas(d).map(
    (u) => previas.get(u.componente + "#" + u.n) || { ...u, etiqueta: "", ejemplo: "", autocompletar: null }
  );
  return { ...d, variables };
}

export function textoConEjemplos(texto, variables, componente) {
  return String(texto || "").replace(/\{\{(\d+)\}\}/g, (marca, n) => {
    const v = (variables || []).find((x) => x.componente === componente && Number(x.n) === Number(n));
    return v && v.ejemplo ? v.ejemplo : marca;
  });
}

// *negrita*, _cursiva_ y ~tachado~ como en WhatsApp (solo para la vista previa)
export function partesFormato(texto) {
  const partes = [];
  const re = /(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)/g;
  let ultimo = 0;
  let m = re.exec(texto || "");
  while (m) {
    if (m.index > ultimo) partes.push({ t: texto.slice(ultimo, m.index) });
    partes.push({ t: m[0].slice(1, -1), e: m[0][0] });
    ultimo = m.index + m[0].length;
    m = re.exec(texto);
  }
  if (ultimo < (texto || "").length) partes.push({ t: texto.slice(ultimo) });
  return partes;
}

// --------------------------------------------------------------------------------------------
// Formulario <-> plantilla
// --------------------------------------------------------------------------------------------
export function plantillaVacia(marcaSlug) {
  return {
    marca_slug: marcaSlug || "",
    nombre: "",
    idioma: "es",
    categoria: "UTILITY",
    encabezado: null,
    cuerpo: { texto: "" },
    pie: "",
    botones: [],
    variables: [],
  };
}

export function botonVacio(tipo) {
  return { tipo, texto: "", url: "", telefono: "" };
}

// Una plantilla guardada (con los componentes de Meta) -> lo que edita la pantalla
export function desdePlantilla(p, marcaSlug) {
  const d = plantillaVacia(marcaSlug);
  d.nombre = p.nombre || "";
  d.idioma = p.idioma || "es";
  d.categoria = String(p.categoria || "UTILITY").toUpperCase();
  const ejemplos = {};
  (p.componentes || []).forEach((c) => {
    const tipo = String(c.type || "").toUpperCase();
    const formato = String(c.format || "").toUpperCase();
    const ej = c.example || {};
    if (tipo === "HEADER") {
      if (formato === "TEXT") {
        d.encabezado = { tipo: "TEXT", texto: c.text || "", archivo_id: null, handle: null };
        ejemplos["encabezado#1"] = (ej.header_text || [])[0] || "";
      } else if (["IMAGE", "VIDEO", "DOCUMENT"].includes(formato)) {
        d.encabezado = {
          tipo: formato,
          texto: "",
          archivo_id: p.encabezado_archivo_id || null,
          handle: (ej.header_handle || [])[0] || null,
        };
      }
    } else if (tipo === "BODY") {
      d.cuerpo = { texto: c.text || "" };
      const fila = (ej.body_text || [])[0] || [];
      fila.forEach((v, i) => {
        ejemplos["cuerpo#" + (i + 1)] = v;
      });
    } else if (tipo === "FOOTER") {
      d.pie = c.text || "";
    } else if (tipo === "BUTTONS") {
      (c.buttons || []).forEach((b, i) => {
        const bt = String(b.type || "").toUpperCase();
        d.botones.push({ tipo: bt, texto: b.text || "", url: b.url || "", telefono: b.phone_number || "" });
        if (bt === "URL") ejemplos["boton:" + i + "#1"] = (b.example || [])[0] || "";
      });
    }
  });
  const guardadas = (p.variables || []).map((v) => ({
    componente: v.componente,
    n: Number(v.n),
    etiqueta: v.etiqueta || "",
    ejemplo: v.ejemplo || "",
    autocompletar: v.autocompletar || null,
  }));
  const base = { ...d, variables: guardadas };
  const completa = sincronizarVariables(base);
  completa.variables = completa.variables.map((v) =>
    v.ejemplo ? v : { ...v, ejemplo: ejemplos[v.componente + "#" + v.n] || "" }
  );
  return completa;
}

// Una de las plantillas sugeridas (ya viene con el formato del formulario)
export function desdeSugerida(s, idioma, marcaSlug) {
  const base = (s.idiomas && s.idiomas[idioma]) || {};
  const d = plantillaVacia(marcaSlug);
  return sincronizarVariables({
    ...d,
    nombre: base.nombre || s.clave || "",
    idioma: base.idioma || idioma,
    categoria: base.categoria || "UTILITY",
    encabezado: base.encabezado || null,
    cuerpo: { texto: (base.cuerpo && base.cuerpo.texto) || "" },
    pie: base.pie || "",
    botones: (base.botones || []).map((b) => ({ tipo: b.tipo, texto: b.texto || "", url: b.url || "", telefono: b.telefono || "" })),
    variables: (base.variables || []).map((v) => ({ ...v })),
  });
}

// Lo que se manda al servidor
export function aPayload(d) {
  const f = sincronizarVariables(d);
  const enc = f.encabezado && f.encabezado.tipo ? f.encabezado : null;
  return {
    marca_slug: f.marca_slug,
    nombre: String(f.nombre || "").trim(),
    idioma: f.idioma,
    categoria: f.categoria,
    encabezado: enc
      ? {
          tipo: enc.tipo,
          texto: enc.texto || "",
          archivo_id: enc.archivo_id || null,
          handle: enc.handle || null,
        }
      : null,
    cuerpo: { texto: f.cuerpo.texto },
    pie: f.pie || "",
    botones: f.botones.map((b) => ({
      tipo: b.tipo,
      texto: b.texto || "",
      url: b.url || "",
      telefono: b.telefono || "",
    })),
    variables: f.variables.map((v) => ({
      componente: v.componente,
      n: v.n,
      etiqueta: v.etiqueta || "",
      ejemplo: v.ejemplo || "",
      autocompletar: v.autocompletar || null,
    })),
  };
}

const rotuloArchivo = { IMAGE: "imagen", VIDEO: "video", DOCUMENT: "documento" };

// Los mismos controles que el servidor (lista vacia = se puede mandar)
export function validar(datos) {
  const d = sincronizarVariables({
    ...datos,
    botones: datos.botones || [],
    cuerpo: datos.cuerpo || { texto: "" },
  });
  const errores = [];
  const nombre = String(d.nombre || "").trim();
  const ejemplo = (componente, n) => {
    const v = d.variables.find((x) => x.componente === componente && Number(x.n) === n);
    return v && String(v.ejemplo || "").trim();
  };

  if (!nombre) errores.push("Poné un nombre para la plantilla.");
  else {
    if (nombre.length > LIMITES.nombre) errores.push("El nombre tiene " + nombre.length + " caracteres y el máximo es " + LIMITES.nombre + ".");
    if (!/^[a-z0-9_]+$/.test(nombre)) errores.push("El nombre solo puede tener minúsculas, números y guion bajo (_), sin espacios ni tildes.");
  }
  if (!/^[a-z]{2,3}(_[A-Z]{2})?$/.test(d.idioma || "")) errores.push("Elegí el idioma (por ejemplo es, en o es_AR).");
  if (!["UTILITY", "MARKETING"].includes(d.categoria)) errores.push("Elegí la categoría: Utilidad o Marketing.");

  const enc = d.encabezado;
  if (enc) {
    if (!["TEXT", "IMAGE", "VIDEO", "DOCUMENT"].includes(enc.tipo)) {
      errores.push("El tipo de encabezado no es válido (texto, imagen, video o documento).");
    } else if (enc.tipo === "TEXT") {
      const texto = String(enc.texto || "").trim();
      if (!texto) errores.push("El encabezado de texto está vacío.");
      if (texto.length > LIMITES.encabezado) errores.push("El encabezado tiene " + texto.length + " caracteres y el máximo es " + LIMITES.encabezado + ".");
      const nums = variablesDe(texto);
      if (nums.length && !(nums.length === 1 && nums[0] === 1)) errores.push("El encabezado puede tener una sola variable y tiene que ser {{1}}.");
      else if (nums.length && !ejemplo("encabezado", 1)) errores.push("A la variable {{1}} del encabezado le falta el ejemplo.");
      const resto = texto.replace(/\{\{\d+\}\}/g, "");
      if (resto.includes("{{") || resto.includes("}}")) errores.push("El encabezado tiene llaves {{ }} mal escritas: la variable es {{1}}.");
    } else if (!(enc.archivo_id || enc.handle)) {
      errores.push("El encabezado con " + rotuloArchivo[enc.tipo] + " necesita un archivo de ejemplo.");
    }
  }

  const texto = String(d.cuerpo.texto || "").trim();
  if (!texto) errores.push("El cuerpo es obligatorio.");
  else {
    if (texto.length > LIMITES.cuerpo) errores.push("El cuerpo tiene " + texto.length + " caracteres y el máximo es " + LIMITES.cuerpo + ".");
    const resto = texto.replace(/\{\{\d+\}\}/g, "");
    if (resto.includes("{{") || resto.includes("}}")) {
      errores.push("El cuerpo tiene llaves {{ }} mal escritas: las variables se escriben {{1}}, {{2}}, {{3}}…");
    }
    const nums = variablesDe(texto);
    if (nums.length) {
      const orden = [];
      nums.forEach((n) => {
        if (!orden.includes(n)) orden.push(n);
      });
      if (!orden.every((n, i) => n === i + 1)) errores.push("Las variables tienen que ser {{1}}, {{2}}, {{3}}… en orden y sin saltear ningún número.");
      if (/^\s*\{\{\d+\}\}/.test(texto)) errores.push("El cuerpo no puede empezar con una variable: poné texto antes.");
      if (/\{\{\d+\}\}\s*$/.test(texto)) errores.push("El cuerpo no puede terminar con una variable: poné texto después.");
      if (/\}\}\{\{/.test(texto)) errores.push("Hay dos variables pegadas ({{1}}{{2}}): poné texto en el medio.");
      orden.forEach((n) => {
        if (!ejemplo("cuerpo", n)) errores.push("A la variable {{" + n + "}} del cuerpo le falta el ejemplo.");
      });
    }
  }

  const pie = String(d.pie || "").trim();
  if (pie) {
    if (pie.length > LIMITES.pie) errores.push("El pie tiene " + pie.length + " caracteres y el máximo es " + LIMITES.pie + ".");
    if (pie.includes("{{") || pie.includes("}}")) errores.push("El pie no puede tener variables.");
  }

  const botones = d.botones;
  if (botones.length > LIMITES.botones) errores.push("Meta deja hasta " + LIMITES.botones + " botones en total y hay " + botones.length + ".");
  botones.forEach((b, i) => {
    const cual = "El botón " + (i + 1);
    if (!["QUICK_REPLY", "URL", "PHONE_NUMBER"].includes(b.tipo)) {
      errores.push(cual + " tiene un tipo que no existe (respuesta rápida, enlace o teléfono).");
      return;
    }
    const t = String(b.texto || "").trim();
    if (!t) errores.push(cual + " no tiene texto.");
    else if (t.length > LIMITES.boton) errores.push(cual + " tiene " + t.length + " caracteres y el máximo es " + LIMITES.boton + ".");
    if (b.tipo === "URL") {
      const url = String(b.url || "").trim();
      if (!url) {
        errores.push(cual + " no tiene enlace.");
        return;
      }
      if (!url.toLowerCase().startsWith("https://")) errores.push(cual + ": el enlace tiene que empezar con https://.");
      if (url.length > LIMITES.url) errores.push(cual + ": el enlace tiene más de " + LIMITES.url + " caracteres.");
      if (url.includes("{{") || url.includes("}}")) {
        const abre = url.split("{{").length - 1;
        const cierra = url.split("}}").length - 1;
        if (!(abre === 1 && cierra === 1 && url.endsWith("{{1}}"))) {
          errores.push(cual + ": la variable del enlace tiene que ser una sola, {{1}}, y estar al final.");
        } else if (!ejemplo("boton:" + i, 1)) {
          errores.push(cual + ": a la variable {{1}} del enlace le falta el ejemplo.");
        }
      }
    } else if (b.tipo === "PHONE_NUMBER") {
      const tel = String(b.telefono || "").trim();
      if (!tel) errores.push(cual + " no tiene número de teléfono.");
      else if (tel.length > LIMITES.telefono) errores.push(cual + ": el teléfono tiene más de " + LIMITES.telefono + " caracteres.");
    }
  });
  const tipos = botones.map((b) => b.tipo);
  const cuenta = (t) => tipos.filter((x) => x === t).length;
  if (cuenta("QUICK_REPLY") > LIMITES.rapidas) errores.push("Meta deja hasta " + LIMITES.rapidas + " respuestas rápidas.");
  if (cuenta("URL") > LIMITES.urls) errores.push("Meta deja hasta " + LIMITES.urls + " botones con enlace.");
  if (cuenta("PHONE_NUMBER") > LIMITES.telefonos) errores.push("Meta deja un solo botón de llamada.");
  const rapidas = tipos.map((t, i) => (t === "QUICK_REPLY" ? i : -1)).filter((i) => i >= 0);
  if (rapidas.length) {
    const alPrincipio = rapidas.every((r, i) => r === i);
    const alFinal = rapidas.every((r, i) => r === tipos.length - rapidas.length + i);
    if (!(alPrincipio || alFinal)) errores.push("Las respuestas rápidas tienen que ir todas juntas, al principio o al final de los botones, sin mezclarse con los otros.");
  }
  d.variables.forEach((v) => {
    if (v.autocompletar && !AUTOCOMPLETAR.some((a) => a.valor === v.autocompletar)) {
      errores.push('El autocompletado "' + v.autocompletar + '" no existe.');
    }
  });
  return errores.filter((e, i) => errores.indexOf(e) === i);
}

// "hace 5 min", "hace 2 h", "ayer"... para la ultima sincronizacion
export function haceCuanto(iso) {
  if (!iso) return "nunca";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "nunca";
  const min = Math.max(0, Math.round((Date.now() - t) / 60000));
  if (min < 1) return "recién";
  if (min < 60) return "hace " + min + " min";
  const h = Math.round(min / 60);
  if (h < 24) return "hace " + h + " h";
  const dias = Math.round(h / 24);
  return dias === 1 ? "ayer" : "hace " + dias + " días";
}

export function minutosDesde(iso) {
  const t = iso ? new Date(iso).getTime() : NaN;
  return Number.isNaN(t) ? Infinity : (Date.now() - t) / 60000;
}
